var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('router-link',{attrs:{"to":_vm.url}},[_c('asset-meta',{attrs:{"resource":_vm.resource}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }